import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";

const Subheading: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p style={{ fontWeight: 600, color: "#111827", marginBottom: 6, marginTop: 16 }}>{children}</p>
);

const linkStyle: React.CSSProperties = { color: "#2563eb" };

export default function Privacy() {
  usePageTitle("Privacy Policy — Lets Go Sauna");
  return (
    <div style={{ maxWidth: 760, margin: "40px auto", padding: "0 24px 80px" }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, color: "#111827", marginBottom: 8 }}>Privacy policy</h1>
      <div style={{ color: "#374151", fontSize: 15, lineHeight: 1.65 }}>
        <p style={{ color: "#6b7280", fontSize: 13, marginBottom: 24 }}>
          Last updated May 23, 2026. Questions? Email{" "}
          <a href="mailto:craighalonen04@gmail.com" style={linkStyle}>craighalonen04@gmail.com</a>.
        </p>
        <Subheading>What we collect</Subheading>
        <p>We collect the information you give us directly — email address (for email sign-up), phone number (if provided), name, and profile details — plus standard server logs (IP address, browser type, pages visited) and the content of messages you send through the platform.</p>
        <Subheading>How we use it</Subheading>
        <p>We use your information to operate Lets Go Sauna: showing your listings, processing bookings, sending booking confirmations and messages, and improving the service. We do not sell your personal data to third parties.</p>
        <Subheading>Payments</Subheading>
        <p>Payments are handled by Stripe. We do not store card numbers. Stripe's privacy policy governs payment data.</p>
        <Subheading>SMS / text messaging</Subheading>
        <p>If you signed up with a phone number, Lets Go Sauna uses it for two purposes: (1) one-time passcodes for sign-in — sent each time you request a code, and (2) transactional booking notifications (requests, confirmations, approvals, declines, and cancellations) — sent only if you opted in. If you signed up with an email address, SMS is not used unless you later add a phone number to your account. Message frequency varies. Message and data rates may apply. You can opt out of booking notifications at any time by replying <strong>STOP</strong> to any message. Reply <strong>HELP</strong> for assistance or email <a href="mailto:craighalonen04@gmail.com" style={linkStyle}>craighalonen04@gmail.com</a>.</p>
        <p>Your mobile number (if provided) is not shared with third parties or affiliates for marketing purposes.</p>
        <Subheading>Your rights</Subheading>
        <p>You may request access to, correction of, or deletion of your personal data at any time by emailing us. We will respond within 30 days.</p>
        <Subheading>Cookies</Subheading>
        <p>We use a single session cookie and localStorage to keep you logged in. No third-party ad tracking cookies.</p>
      </div>
    </div>
  );
}
